<template>
  <div class="uk-offcanvas-bar scroller">
    <button class="uk-offcanvas-close" type="button" uk-close></button>
    <form class="uk-form-stacked uk-margin-medium">
      <legend class="uk-legend">Export Settings</legend>
      <hr>
      <!-- ACCORDIAN -->
      <ul uk-accordion="multiple: true">
        <!-- RENAME -->
        <li class="">
          <a class="uk-accordion-title uk-text-muted" v-bind:style="{color: activeRenameColor}" href="#">Rename</a>
          <div class="uk-accordion-content">
            <toggle-button class="uk-float-right " v-model="renameSlider" color="#2dde98" :disabled="true" :height="16" :width="40" :sync="true" :labels="true"/>
            <label class="uk-form-label uk-text-muted" for="form-stacked-text">File Name:</label>                  
            <div class="uk-form-controls">
                <input class="uk-input uk-form-small" ref="fileNameTextBox" autocomplete="off" v-model="choosenFileName" type="text" placeholder="File Name...">
            </div>
            <label class="uk-form-label uk-margin-left uk-margin-small-top uk-margin-bottom"><i><span class="uk-text-muted">Ex:</span> {{ formattedFileNameExample }}</i></label>
            <label class="uk-form-label uk-text-muted" for="form-stacked-text">Snippets (click to add)</label>
            <table class="uk-table uk-table-small uk-table-hover uk-width-3-3 uk-text-small uk-text-muted uk-margin-remove" style="border: 1px solid rgba(255,255,255,.2);">
                <tbody>                        
                    <tr @click="addSnippet('{{filename}}')">
                        <td><span v-pre>{{filename}}</span></td>
                        <td>File Name</td>
                    </tr>
                    <tr @click="addSnippet('{{date}}')">
                        <td><span v-pre>{{date}}</span></td>
                        <td>Current Date</td>
                    </tr>
                    <tr @click="addSnippet('{{n}}')">
                        <td><span v-pre>{{n}}</span></td>
                        <td>File Number</td>
                    </tr>
                    <tr @click="addSnippet('{{totaln}}')">
                        <td><span v-pre>{{totaln}}</span></td>
                        <td>Total Num Files</td>
                    </tr>                          
                </tbody>
            </table>
            <label class="uk-form-label uk-text-muted uk-margin-top" for="form-stacked-text">Folder Name:</label>                  
            <div class="uk-form-controls">
                <input class="uk-input uk-form-small" autocomplete="off" v-model="choosenFolderName" type="text" placeholder="Watermark Photos">
            </div>            
          </div>
          <hr>
        </li>        
        <li>
          <a class="uk-accordion-title uk-text-muted" :class="[{'wm-green2': maxXY}]" href="#">Resize</a>
          <div class="uk-accordion-content">
            <!-- DISABLE RESIZE -->
            <label v-if="globalSessionInfo.compressOnImport == true" class="uk-form-label uk-text-muted">Images have already been resized.</label>
            <div v-else class="resizeAccordian"> 
              <!-- PRESET -->
              <div class="uk-margin">
                <label class="uk-form-label uk-text-muted">Preset:</label>
                <div class="">
                    <select v-model="maxXY" style="width: 210px; background-color: #393939;" class="uk-select uk-form-small">
                        <option value="400">400px - Mobile</option>
                        <option value="800">800px - Web</option>
                        <option value="1280">1280px - Desktop</option>
                        <option value="1920">1920px - Very Large <span class="uk-text-small"><i>(slower)</i></span></option>
                    </select>
                </div>
              </div>              
              <!-- SIZE -->
              <div class="uk-margin">
                <label class="uk-form-label uk-text-muted">Longest Side:</label>
                <div class="uk-flex">
                  <div class="uk-form-controls">
                    <input v-model="maxXY" class="uk-input uk-form-small" type="text" placeholder="... px">
                  </div>
                  <div class="uk-form-controls uk-margin-small-left uk-margin-auto-vertical">
                    <a @click.prevent href="#" style="color: gray;" uk-icon="question"></a>
                    <div uk-dropdown="pos: bottom-right; delay-show: 400;" class="uk-padding-small uk-text-small" style="border-radius: 5px; width: 84px;">The longest edge of your images will be resized to this value.</div>
                  </div>
                </div>
              </div>
              <!-- QUALITY -->
              <div class="uk-margin">
                <label class="uk-form-label">Quality:</label>
                <div class="uk-flex">
                  <div class="uk-width-2-3 uk-margin-auto-vertical">
                    <vue-slider ref="vueSlider" v-model="qualityValueSlider" :tooltip="'none'"></vue-slider>
                  </div>
                  <div class="uk-width-1-3 uk-margin-left">
                    <input class="uk-input uk-form-width-xsmall uk-form-small" type="text" v-model="qualityValueSlider"><span>%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>
        </li>        
        <!-- FILE TYPE -->
        <li>
          <a class="uk-accordion-title uk-text-muted" href="#">File Type</a>
          <div class="uk-accordion-content">
            <div class="uk-flex uk-flex-center">
              <a :class="['file-type-export', {'file-type-active': this.choosenFileType === 'jpg'}]" @click="choosenFileType = 'jpg'">
                <div class="uk-padding-small">
                  <img src="/img/illustrations/file_types/jpg_icon.png" width="50px">
                </div>
              </a>
              <a :class="['file-type-export', {'file-type-active': this.choosenFileType === 'png'}]" @click.prevent="">
                <div class="uk-padding-small">
                  <img src="/img/illustrations/file_types/png_icon.png" width="50px">
                </div>
              </a>
              <a :class="['file-type-export', {'file-type-active': this.choosenFileType === 'bmp'}]" @click.prevent="">
                <div class="uk-padding-small">
                  <img src="/img/illustrations/file_types/bmp_icon.png" width="50px">
                </div>
              </a>              
            </div>
          </div>
          <hr>
        </li>
      </ul>
      <!-- Upload to Cloud Toggle 
      <table @click="uploadToCloudToggleFunc" class="uk-table uk-table-small uk-table-hover uk-width-3-3 uk-text-small uk-text-muted uk-margin-remove noselect" style="cursor: pointer;">
        <tbody>                        
            <tr>
              <td><i class="material-icons uk-inline">cloud_upload</i> Upload to Cloud Gallery </td>
              <td><toggle-button class="uk-float-right " v-model="uploadToCloud" color="#2dde98" :disabled="false" :height="16" :width="34" :sync="true" :labels="false"/></td>
            </tr>                    
        </tbody>
      </table> 
      <div v-show="uploadToCloud">
        <label class="uk-form-label uk-text-muted uk-margin-top" for="form-stacked-text">Album Name:</label>                  
        <div class="uk-form-controls">
            <input :class="['uk-input uk-form-small', {'highlight-red': highlightRed}]" autocomplete="off" v-model="choosenAlbumName" type="text" placeholder="Untitled">            
        </div>
      </div>        
      -->

      <!-- No Watermark Applied -->
      <p v-show="!(globalSessionInfo.appliedWatermark)" style="color: rgb(244, 194, 13, 0.6)" class="uk-margin-remove uk-padding-remove uk-text-small uk-text-center">
        Psst: no watermark choosen!
      </p>
      <!-- Export Multi -->
      <a v-if="globalImages.uploadedImages.length > 1" @click.prevent="exportImagesStart" class="uk-button uk-button-danger uk-margin-bottom uk-width-1-1" style="border-radius: 2px;" :disabled="exportText === 'Exporting'">
        <b>{{ exportText }} &nbsp; <span v-if="exportText === 'Exporting'" uk-spinner="ratio: 0.6"></span></b>
      </a>
      <!-- Export Single -->
      <a v-else @click="singleImageDownload" id="single-image"  class="uk-button uk-button-danger uk-margin-bottom uk-width-1-1" style="border-radius: 2px;">
        <b>{{ exportText }}</b>
      </a>   
      <!-- Queue Count Footer -->
      <p class="uk-margin-remove uk-padding-remove uk-text-small uk-text-muted uk-text-center">
        <i>Queue: {{globalImages.uploadedImages.length}} images in {{choosenFileType}}.</i>
      </p>
    </form>      
  </div>
</template>

<script>
  import Vue from 'vue'

  import {resizeImage} from '../../assets/js/fitters/resizeImage.js'

  // NPM Modules 
  import JSZip from 'jszip'
  import vueSlider from 'vue-slider-component'  
  import UIkit from 'uikit'
  import firebase from 'firebase/app'
  import rate from 'vue-rate';  
  Vue.use(rate)

  var FileSaver = require('file-saver');

  export default {
    name: 'export-apply',
    components: {
      
    },   
    data() {
      return {   
        exportText: 'Export',
        choosenFileName: '',
        choosenFolderName: '',
        choosenAlbumName: '',
        renameSlider: false,
        activeRenameColor: null,
        activeResizeColor: null,
        choosenFileType: 'jpg',
        qualityValueSlider: 100,
        uploadToCloud: false,
        highlightRed: false,
        workingFileList: [],
        maxXY: ""
      }
    },
    methods: {
      resizeAllImages() {
        var me;
        me = this;

        // throw up "Resizing" notification        
        this.$notify({
            title: 'Resizing',
            group: 'applying',
            duration: 100000,
            data: {length: me.globalImages.uploadedImages.length}
        });
        
        // create array [0,1,2...] of total number of iamges
        this.workingFileList = Array.apply(null, {length: me.globalImages.uploadedImages.length}).map(Number.call, Number);
  
        // run it
        processResizeImages(this.workingFileList)

        async function processResizeImages(array) {
          for (const idx of array) {
            // update counter for notification to tell user which image is being processed
            Vue.set(me.globalSessionInfo, 'counterIndex', idx)

            // await result... will return: result[0] = resizedImgURL (url), result[1] = imgDims (object)
            var result = await resizeImage(me.globalImages.uploadedImages[idx].thumbnailURL, me.maxXY, me.imageQuality)
                    
            // update thumbnailURL with resized image (returned by module function)
            Vue.set(me.globalImages.uploadedImages[idx], 'thumbnailURL', result[0])   
            // take new image dimensions and update globalImages
            Vue.set(me.globalImages.uploadedImages[idx].properties, 'height', result[1].oldHeight)
            Vue.set(me.globalImages.uploadedImages[idx].properties, 'width', result[1].oldWidth)
            Vue.set(me.globalImages.uploadedImages[idx].properties, 'scaledHeight', result[1].newHeight)
            Vue.set(me.globalImages.uploadedImages[idx].properties, 'scaledWidth', result[1].newWidth)  
            Vue.set(me.globalImages.uploadedImages[idx].properties, 'aspectRatio', result[1].aspectRatio)   
            // note images in session have already been resized
            Vue.set(me.globalSessionInfo, 'compressOnImport', true) 
            // mark that image has been scaled
            Vue.set(me.globalImages.uploadedImages[idx].properties, 'isScaled', true)                           
          }
          // DONE. Clear notifications
          me.$notify({
              group: 'applying',
              type: 'info',
              clean: true,
          });                    

          // if watermark, apply
          if (me.globalSessionInfo.appliedWatermark) {
            me.$parent.applyWatermark(me.globalSessionInfo.appliedWatermarkIndex, 'export')
          } else {
            // resize + apply are done... move to export
            me.exportImagesProcess()
          }

        }
            
        
      },
      exportImagesStart() {
        if (this.globalSessionInfo.currentUser.isLoggedIn) {
          var me;
          me = this;

          // Effectively using this as "status" and also for button control
          this.exportText = 'Exporting'

          // Progress Bar Start
          this.startProgress()  
      
          // delaying export process to give vue time to change DOM
          setTimeout(() => { 

            // resize if selected    
            if (this.maxXY && !(this.compressOnImport)) {
              this.resizeAllImages()
            } else {
              this.exportImagesProcess()
            } 
            
          }, 100)

          // Start Upload
          if (this.uploadToCloud) {
            this.uploadImageProcess()
          }
        } else {
          // IF USER NOT LOGGED IN (below)
          UIkit.modal('#register-modal', {bgClose:false, bgEsc:false}).show();      
        }
      },
      uploadImageProcess() {
        var me;
        me = this;

        // FIREBASE
        let userId = firebase.auth().currentUser.uid;   
        let albumRef = firebase.firestore().collection('gallery').doc(userId).collection('albums');
        let albumRefDocId 
        let today = new Date();
        let storage = firebase.storage()              
        
        // Check if Album Name is null
        if (this.choosenAlbumName === null || this.choosenAlbumName === '') {
          this.highlightRed = true;
          this.choosenAlbumName = 'Untitled'
        } else {
            this.highlightRed = false;
        }


        // Create album Ref and add album to Firestore
        albumRef.add({
            albumName: me.choosenAlbumName,
            createdOn: today.toISOString().substring(0, 10),
            createdOnPrecise: today.toISOString(),
            images: []
        }).then(function(docRef) {
          albumRefDocId = docRef.id
            console.log("Album created with ID: ", docRef.id);
          // Now that Firestore album is created... start Storage upload
          uploadIterator()             
        })
        .catch(function(error) {
          console.error("Error adding document: ", error);
        });         

        //Get files  
        async function uploadIterator() {
          // Start Upload Notification
          Vue.set(me.globalSessionInfo, 'uploadingImageIndex', 0)  
          me.$notify({
              title: 'Uploading',
              group: 'uploading',
              duration: 100000,
              data: {length: me.globalImages.uploadedImages.length}
          });                                 
          
          var imageNumberArray = Array.apply(null, {length: me.globalImages.uploadedImages.length}).map(Number.call, Number) //makes simple array [0,1,2,...]      
          for (let i of imageNumberArray) {
              if (me.globalImages.uploadedImages[i].dataURL) {
                var imageBlobURL = me.globalImages.uploadedImages[i].dataURL;
              } else {
                var imageBlobURL = me.globalImages.uploadedImages[i].thumbnailURL;
              }
              
              let imageFileName = me.formattedFileName(i)                    

              let blob = await fetch(imageBlobURL).then(r => r.blob());
              await uploadAsyncImage(blob, imageFileName, i);     
              
              // if we finished our loop ... we're done :) 
              if (i === imageNumberArray.slice(-1)[0]) {
                me.$notify({
                  group: 'uploading',
                  clean: true,
                });

                me.$notify({
                  title: 'Upload Complete <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>',
                  text: 'Successfully Uploaded',
                  group: 'uploadComplete',
                  type: 'success',
                  duration: 1000
                }); 
              }
          }
        }          
        
        //Handle waiting to upload each file using promise
        async function uploadAsyncImage(blob, imageFileName, i) {
            //Upload file
            var uploadTask = firebase.storage().ref('user/' + userId + '/images/' + albumRefDocId + '/' + imageFileName).put(blob);
            await uploadTask

            // Register three observers:
            // 1. 'state_changed' observer, called any time the state changes
            // 2. Error observer, called on failure
            // 3. Completion observer, called on successful completion
            uploadTask.on('state_changed', function(snapshot){
              // Observe state change events such as progress, pause, and resume
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              // console.log('Upload is ' + progress + '% done');
              switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                  // console.log('Upload is paused');
                  break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                  // console.log('Upload is running');
                  break;
              }
            }, function(error) {
              // Handle unsuccessful uploads
            }, function() {
              // Handle successful uploads on complete
              Vue.set(me.globalSessionInfo, 'uploadingImageIndex', i) 
              // For instance, get the download URL: https://firebasestorage.googleapis.com/...
              uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                // console.log('File available at', downloadURL);
                // Add downloadURL to Firestore ablum.images array
                albumRef.doc(albumRefDocId).update({
                  images: firebase.firestore.FieldValue.arrayUnion(downloadURL),
                  documentId: albumRefDocId
                })                   
              });
            });
        }          
      },      
      exportImagesProcess() {
        //. NOTE: this is for download of multiple files
        var me;
        var me = this;
        let fn = '';
        var zip = new JSZip();    
        
        // start "exporting" notification
        me.$notify({
            title: 'Exporting ',
            group: 'exporting',
            data: {length: me.globalImages.uploadedImages.length},
            duration: 100000
        });  

        

        // BASE 64 https://bitbucket.org/snippets/integrateus/8A69Lj
        
        // Using dataURL
        for (let i = 0; i <  this.globalImages.uploadedImages.length; i++) {
          // user selected watermark if dataURL is populated:
          if (this.globalImages.uploadedImages[i].dataURL) {
            var exportImage = this.globalImages.uploadedImages[i].dataURL
          } else {
            var exportImage = this.globalImages.uploadedImages[i].thumbnailURL
          }

          // zip.js requires binary for zipping.. this converts objectURL into binary data
          function urlToPromise(url) {
            return new Promise(function(resolve, reject) {
              JSZipUtils.getBinaryContent(url, function (err, data) {
                  if(err) {
                      reject(err);
                  } else {
                      resolve(data);
                  }
              });
            });
          }
          zip.file(me.formattedFileName(i), urlToPromise(exportImage), {binary:true});
        }
  
        // set default folder name if not set by user
        if (this.choosenFolderName === '' || this.choosenFolderName === null) {
          this.choosenFolderName = 'Watermark Photos'
        }

        zip.generateAsync({type:"blob"})
        .then(function(content) {
            // see FileSaver.js
            FileSaver.saveAs(content, me.choosenFolderName + ".zip");
            return me.exportImagesFinished()
        });        
              
      },
      singleImageDownload() {
        /* little obfuscated here.. but Chrome has a limit on href length in an anchor tag so putting dataURL in it causes
        chrome to throw a "Failed - Network Error".. way around this is to swap out the href to an ObjectURL (which is much shorter)
        Below loads the image into a canvas, exports as blob, when blob is loaded, sets href = blob then programatically click link to download
        */

       /* UPDATE
       I may not need to do this at all ! because I updated import to store blobs instead of dataURL... so no need to convert. Scott is smart. 
       */

     
        var me;
        me = this;
         /*
        if (me.globalImages.uploadedImages[0].properties.isScaled || me.globalImages.uploadedImages[0].dataURL) {
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext('2d');

          // create a new image object
          var img = new Image();

          // once image loads draw it to canvas
          img.onload = function () {
            //draw background image
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);


            canvas.toBlob(function(blob) {
              var newImg = document.createElement('img'),
              url = URL.createObjectURL(blob);

              // when object url is exported and avail in new image, save it
              newImg.onload = function() {                
                var link = document.createElement('a');
                link.href = url;
                link.download = me.formattedFileName(0);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                me.exportImagesFinished()
                // no longer need to read the blob so it's revoked
                URL.revokeObjectURL(url);
              };
              newImg.src = url;

            }, 'image/jpeg', me.qualityValueSlider);
          }; 

          if (me.globalImages.uploadedImages[0].dataURL) {
            img.src = me.globalImages.uploadedImages[0].dataURL;  
          } else {
            img.src = me.globalImages.uploadedImages[0].thumbnailURL;
          }
        } else {              
          var link = document.createElement('a');
          link.href = me.globalImages.uploadedImages[0].thumbnailURL;;
          link.download = me.formattedFileName(0);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.exportImagesFinished()
        }
        */
      
        var img = new Image();
        if (me.globalImages.uploadedImages[0].dataURL) {
          img.src = me.globalImages.uploadedImages[0].dataURL;  
        } else {
          img.src = me.globalImages.uploadedImages[0].thumbnailURL;
        }        

        img.onload = function () {
          var link = document.createElement('a');
          link.href = img.src;
          link.download = me.formattedFileName(0);
          document.body.appendChild(link);
          link.click(); 
          document.body.removeChild(link);
          this.exportImagesFinished()
        }

      },
      exportImagesFinished() {
        // clean up notifications
        this.$notify({
          group: 'exporting',
          clean: true          
        })

        // export complete notification
        this.$notify({
          title: 'Export Complete <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>',
          text: 'Successfully Exported',
          group: 'loaded',
          type: 'success',
          duration: 3000
        });  

        // set export status back
        this.exportText = 'Export'

        // progress bar finish
        this.finishProgress()

        this.promptFeedback()
      },
      promptFeedback() {
        // Ask for feedback for 1 in 5 users
        let randLikely = Math.floor(Math.random() * 3); // 1 in 3
        let randUnlikely = Math.floor(Math.random() * 10); // 1 in 10

        // use "openFeedbackModal" to openFeedbackModal
        if (this.globalSessionInfo.currentUser.isLoggedIn) {
          // ask for feedback more
          if (randUnlikely === 1) {
            UIkit.modal('#export-feedback-modal', {bgClose:false, bgEsc:false}).show();                
          } else {
            return
          }          
        }

        // do not take feedback from anon users :/ i'd like to but it makes firebase sloppy
        
      },
      startProgress () {
          this.$Progress.start()
      },
      setProgress (num) {
          this.$Progress.set(num)
      },
      increaseProgress (num) {
          this.$Progress.increase(num)
      },
      decreaseProgress (num) {
          this.$Progress.decrease(num)
      },
      finishProgress () {
          this.$Progress.finish()
      },
      failProgress () {
          this.$Progress.fail()
      },
      addSnippet(value) {
        this.choosenFileName = this.choosenFileName + value
      },
      formattedFileName: function(i) {
        if (this.choosenFileName) {
          var funcVar;
          funcVar = this.choosenFileName 

          if (funcVar.includes('{{filename}}')) {
            let strSwap = this.globalImages.uploadedImages[i].fileName.replace(/\.[^/.]+$/, "")
            funcVar = funcVar.replace('{{filename}}', strSwap)
          } 
          
          if (funcVar.indexOf('{{n}}') === -1 && funcVar.indexOf('{{filename}}') === -1) {
            // If no uniqueness in filename, add enumerator
            funcVar = funcVar + '-' + '{{n}}'
          }

          if (funcVar.includes('{{date}}')) {
            let today = new Date();
            today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            funcVar = funcVar.replace('{{date}}', today)
          } 

          if (funcVar.includes('{{n}}')) {
            funcVar = funcVar.replace('{{n}}', i+1)
          }

          if (funcVar.includes('{{totaln}}')) {
            funcVar = funcVar.replace('{{totaln}}', this.globalImages.uploadedImages.length)
          }
          
          if (funcVar) {
            return funcVar + '.' + this.choosenFileType
          }
        } else {
            return this.globalImages.uploadedImages[i].fileName 
          }

      },
      uploadToCloudToggleFunc() {   
        let me;
        me = this;         

        if (this.globalSessionInfo.currentUser.isLoggedIn) {
          // Update toggle to true or false
          this.uploadToCloud = (this.uploadToCloud === false) ? true : false;
          // Update button text
          this.exportText = (this.uploadToCloud === true) ? 'Export and Upload' : 'Export'
        } else {
          // popup saying you should create account
          UIkit.modal.confirm('<i class="material-icons uk-inline" style="color: #11bb77; font-size: 48px;">person_add</i> <b>Create an account?</b><hr> You must have an account to save images to your personal Gallery.<br><br> Click "Ok" to create an account or "Cancel" to continue without saving to the cloud.')
          .then(function () {
              me.$router.push('register')
          }, function () {
              me.saveSuccessful()
          });   
        }
        
      }      
    },
    mounted() {    
      var me;
      me = this; 
      this.$root.$once('eventBusStartExport', () => {
        // Close modal
        UIkit.modal('#register-modal').hide()
        // Start export once user has been created and marks have been pulled back from firestore
        // check every 600 secs that user is created, then remove check
        var repeatCheck = setInterval(function() {
          if (me.globalSessionInfo.currentUser.isLoggedIn) {
            clearInterval(repeatCheck);
            // had to add beforeDestroy and turn event listener off because it was getting triggered more than once
            me.exportImagesStart()            
          }
        }, 600);        
      });
    },  
    beforeDestroy() {
      this.$root.$off('eventBusStartExport') // had to add this because emit was being triggered more than once for some reason (causing multiple exports)
    },
    filters: {  
      addExtension: function (value) {
        if (!value) return ''
        value = value.toString()
        return value + '.jpg'
      }
    },    
    computed: {
      formattedFileNameExample: function() {
        var funcVar;
        funcVar = this.choosenFileName

        if (funcVar.includes('{{filename}}')) {
          let strSwap = this.globalImages.uploadedImages[0].fileName.replace(/\.[^/.]+$/, "")
          funcVar = funcVar.replace('{{filename}}', strSwap)
        } 
        
        if (funcVar.includes('{{date}}')) {
          let today = new Date();
          today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
          funcVar = funcVar.replace('{{date}}', today)
        } 

        if (funcVar.includes('{{n}}')) {
          funcVar = funcVar.replace('{{n}}', '1')
        }

        if (funcVar.includes('{{totaln}}')) {
          funcVar = funcVar.replace('{{totaln}}', this.globalImages.uploadedImages.length)
        }
        
        if (funcVar) {
          return funcVar + '.' + this.choosenFileType
        }
      }
    },
    watch: {
      'choosenFileName': function() {
          if (this.choosenFileName) {
            this.renameSlider = true;
            this.activeRenameColor = '#11BB77 !important';
          }

          if (this.choosenFileName === "") {
            this.renameSlider = false;
            this.activeRenameColor = ''
          }

          this.$refs.fileNameTextBox.focus();
      },
      'maxXY': function() {
          if (Number.isInteger || "") {
            return
          } else {
            console.log('Must use integer value')
          }

      }               
    }
  }
</script>

<style scoped>
  .file-type-export {
    background: rgba(146, 146, 146, 0.6);
    border-bottom: 2px solid transparent;
  }

  .file-type-export:hover {
    background: rgba(146, 146, 146, 0.8);
    border-bottom: 2px solid #EAB126;
  }

  .file-type-active {
    transition: background-color 0.4s ease;
    background-color: #11bb77;
    pointer-events: none;
  }

  .wm-green2 {
    color: #11bb77 !important;
  }
</style>
